<template>
  <div class="main-form">
     <!-- 加载指示器 -->
    <div v-if="isLoading" class="loading-bar">
      <div class="loading-bar-progress"></div>
    </div>
    <div class="header">
      <h1>
        表单
        <h3>{{ pageTitle }}</h3>
      </h1>
      <div class="toolbar1" v-if="!isListView">
        <button class="add-btn" @click="toggleView">
          <span><i class="fas fa-list"></i> 列表</span>
        </button>
      </div>
      <div class="toolbar" v-if="isListView">
        <button class="filter-btn" @click="toggleFilter">
          <i class="fas fa-filter"></i> 筛选
        </button>
        <div class="search-bar">
          <i class="fas fa-search" @click="search()"></i>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="公司、银行卡号、城市、开户行"
          />
        </div>
      </div>
    </div>
    <!-- 筛选侧边栏 -->
    <div
      :class="['filter-sidebar', { 'filter-sidebar-open': isFilterOpen }]"
      v-if="!isMobile && isListView"
    >
      <div class="filter-header">
        <button @click="resetFilter"><i class="fas fa-redo"></i> 重置</button>
        <button @click="applyFilter"><i class="fas fa-search"></i> 搜索</button>
      </div>
      <div class="filter-body">
        <label><i class="fas fa-building"></i> &nbsp;公司</label>
        <input type="text" v-model="filter.company" placeholder="公司" />

        <label><i class="fas fa-envelope"></i> &nbsp;邮箱</label>
        <input type="text" v-model="filter.email" placeholder="邮箱" />

        <label><i class="fas fa-industry"></i> &nbsp;行业/职位</label>
        <input
          type="text"
          v-model="filter.industryPosition"
          placeholder="行业/职位"
        />

        <label><i class="fas fa-city"></i> &nbsp;城市</label>
        <input type="text" v-model="filter.city" placeholder="城市" />

        <label><i class="fas fa-credit-card"></i> &nbsp;银行卡号</label>
        <input
          type="text"
          v-model="filter.bankCardNumber"
          placeholder="银行卡号"
        />

        <label><i class="fas fa-university"></i> &nbsp;开户行</label>
        <input type="text" v-model="filter.bankName" placeholder="开户行" />

        <label><i class="fas fa-hand-holding-usd"></i> &nbsp;还款方式</label>
        <select v-model="filter.repaymentMethod" placeholder="选择">
          <option value="等额本息">等额本息</option>
          <option value="按月付息到期还本">按月付息到期还本</option>
        </select>

        <label><i class="fas fa-calendar-alt"></i> &nbsp;还款期数</label>
        <input
          type="number"
          v-model="filter.repaymentPeriods"
          placeholder="还款期数"
        />

        <label><i class="fas fa-money-bill-wave"></i> &nbsp;额度 (从-到)</label>
        <input
          type="number"
          v-model="filter.minCreditLimit"
          placeholder="最低额度"
        />
        <input
          type="number"
          v-model="filter.maxCreditLimit"
          placeholder="最高额度"
        />

        <label><i class="fas fa-dollar-sign"></i> &nbsp;提款金额 (从-到)</label>
        <input
          type="number"
          v-model="filter.minWithdrawalAmount"
          placeholder="最低金额"
        />
        <input
          type="number"
          v-model="filter.maxWithdrawalAmount"
          placeholder="最高金额"
        />

        <label
          ><i class="fas fa-calendar-alt"></i> &nbsp;创建时间 (从-到)</label
        >
        <input type="date" v-model="filter.startDate" placeholder="开始时间" />
        <input type="date" v-model="filter.endDate" placeholder="结束时间" />
      </div>
    </div>

    <!-- 手机端的筛选弹出层 -->
    <div v-if="isMobile && isFilterOpen && isListView" class="mobile-filter">
      <div class="mobile-filter-header">
        <button @click="resetFilter"><i class="fas fa-redo"></i> 重置</button>
        <button @click="applyFilter"><i class="fas fa-search"></i> 搜索</button>
      </div>
      <div class="mobile-filter-body">
        <div>
          <label><i class="fas fa-building"></i> </label>
          <input type="text" v-model="filter.company" placeholder="公司" />
        </div>
        <div>
          <label><i class="fas fa-envelope"></i> </label>
          <input type="text" v-model="filter.email" placeholder="邮箱" />
        </div>
        <div>
          <label><i class="fas fa-industry"></i> </label>
          <input
            type="text"
            v-model="filter.industryPosition"
            placeholder="行业/职位"
          />
        </div>
        <div>
          <label><i class="fas fa-city"></i> </label>
          <input type="text" v-model="filter.city" placeholder="城市" />
        </div>
        <div>
          <label><i class="fas fa-credit-card"></i> </label>
          <input
            type="text"
            v-model="filter.bankCardNumber"
            placeholder="银行卡号"
          />
        </div>
        <div>
          <label><i class="fas fa-university"></i></label>
          <input type="text" v-model="filter.bankName" placeholder="开户行" />
        </div>
        <div>
          <label><i class="fas fa-hand-holding-usd"></i></label>
          <select v-model="filter.repaymentMethod">
            <option value="还款方式">还款方式</option>
            <option value="等额本息">等额本息</option>
            <option value="按月付息到期还本">按月付息到期还本</option>
          </select>
        </div>
        <div>
          <label><i class="fas fa-calendar-alt"></i></label>
          <input
            type="number"
            v-model="filter.repaymentPeriods"
            placeholder="还款期数"
          />
        </div>
        <div>
          <label><i class="fas fa-money-bill-wave"></i></label>
          <input
            type="number"
            v-model="filter.minCreditLimit"
            placeholder="最低额度"
          />
        </div>
        <div>
          <label><i class="fas fa-money-bill-wave"></i></label>
          <input
            type="number"
            v-model="filter.maxCreditLimit"
            placeholder="最高额度"
          />
        </div>
        <div>
          <label><i class="fas fa-dollar-sign"></i></label>
          <input
            type="number"
            v-model="filter.minWithdrawalAmount"
            placeholder="最低金额"
          />
        </div>
        <div>
          <label><i class="fas fa-dollar-sign"></i></label>
          <input
            type="number"
            v-model="filter.maxWithdrawalAmount"
            placeholder="最高金额"
          />
        </div>
        <div>
          <label><i class="fas fa-calendar-alt"></i>创建开始时间</label>
          <input
            type="date"
            v-model="filter.startDate"
            placeholder="开始时间"
          />
        </div>
        <div>
          <label><i class="fas fa-calendar-alt"></i>创建结束时间</label>
          <input type="date" v-model="filter.endDate" placeholder="结束时间" />
        </div>
      </div>
      <button class="close-mobile-filter" @click="toggleFilter">X</button>
    </div>

    <div class="table-container" v-if="isListView">
      <table class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>银行卡号</th>
            <th v-if="!isMobile">邮箱</th>
            <th v-if="!isMobile">开户行</th>
            <th v-if="!isMobile">公司</th>
            <th v-if="!isMobile">行业职位</th>
            <th v-if="!isMobile">城市</th>
            <th v-if="!isMobile">还款方式</th>
            <th v-if="!isMobile">还款期数</th>
            <th v-if="!isMobile">年化(100%)</th>
            <th v-if="!isMobile">额度</th>
            <th v-if="!isMobile">提款金额</th>
            <th v-if="!isMobile">用途</th>
            <th v-if="!isMobile">身份证人像</th>
            <th v-if="!isMobile">身份证国徽</th>
            <th v-if="!isMobile">创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in filteredAndPaginatedData" :key="row.id">
            <td>{{ row.id }}</td>
            <td>{{ row.bankCardNumber }}</td>
            <td v-if="!isMobile">{{ row.email }}</td>
            <td v-if="!isMobile">{{ row.bankName }}</td>
            <td v-if="!isMobile">{{ row.company }}</td>
            <td v-if="!isMobile">{{ row.industryPosition }}</td>
            <td v-if="!isMobile">{{ row.city }}</td>
            <td v-if="!isMobile">{{ row.repaymentMethod }}</td>
            <td v-if="!isMobile">{{ row.repaymentPeriods }}</td>
            <td v-if="!isMobile">{{ row.annualRate }}</td>
            <td v-if="!isMobile">{{ row.creditLimit }}</td>
            <td v-if="!isMobile">{{ row.withdrawalAmount }}</td>
            <td v-if="!isMobile">{{ row.purpose }}</td>
            <td v-if="!isMobile">
              <img
                :src="row.idCardFront"
                alt="身份证人像"
                @click="enlargeImage(row.idCardFront)"
              />
            </td>
            <td v-if="!isMobile">
              <img
                :src="row.idCardBack"
                alt="身份证国徽"
                @click="enlargeImage(row.idCardBack)"
              />
            </td>
            <td v-if="!isMobile">{{ row.createdAt }}</td>
            <td>
              <button v-if="isMobile" @click="showDetail(row)">
                <i class="fas fa-eye"></i>
              </button>
              <div v-if="!isMobile">
                <button @click="editRow(row)">
                  <i class="fas fa-edit"></i>
                </button>
                <button @click="deleteRow(row.id)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination" v-if="isListView">
      <div>
        <label class="showPage" for="pageSize">每页显示:</label>
        <select v-model="pageSize" id="pageSize">
          <option value="10">10条</option>
          <option value="20">20条</option>
          <option value="30">30条</option>
          <option value="50">50条</option>
        </select>
      </div>
      <div>
      <button v-if="!isMobile" @click="prevPage" :disabled="currentPage === 1">
        上一页
      </button>
      <button v-if="isMobile" @click="prevPage" :disabled="currentPage === 1">
        ◀
      </button>
      <div class="jump">
        跳转到&nbsp;<input
          type="number"
          v-model.number="gotoPage"
          min="1"
          :max="totalPages"
          @change="jumpToPage"
        />&nbsp;页
      </div>
      <button
        v-if="!isMobile"
        @click="nextPage"
        :disabled="currentPage >= totalPages"
      >
        下一页
      </button>
      <button
        v-if="isMobile"
        @click="nextPage"
        :disabled="currentPage >= totalPages"
      >
        ▶
      </button>
    </div>
      <div>
        <span class="page-info"
          >第 {{ currentPage }} 页,共 {{ totalPages }} 页</span
        >
      </div>
    </div>

    <div v-if="isDetailOpen && isListView" class="detail-modal">
      <div class="detail-content">
        <button class="close-detail" @click="isDetailOpen = false">X</button>
        <table>
          <tr v-for="(value, key) in selectedRow" :key="key">
            <td>{{ keyTranslations[key] || key }}</td>
            <td>{{ value }}</td>
          </tr>
        </table>
        <div class="actions">
          <button @click="editRow(selectedRow)">
            <i class="fas fa-edit"></i>
          </button>
          <button @click="deleteRow(selectedRow.id)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="detail" v-if="isCreating">
      <form @submit.prevent="submitForm">
        <br />
        <hr class="myhr" />
        <br />
        <div class="row">
          <div class="control-label"><i class="fas fa-id-badge"></i>ID:</div>
          <div class="box-body">
            <input type="text" v-model="formData.id" disabled />
          </div>
        </div>

        <!-- 公司 -->
        <div class="row">
          <div class="control-label"><i class="fas fa-building"></i>公司:</div>
          <div class="box-body">
            <input type="text" v-model="formData.company" required />
          </div>
        </div>

        <div class="row">
          <div class="control-label"><i class="fas fa-briefcase"></i>职位:</div>
          <div class="box-body">
            <input type="text" v-model="formData.industryPosition" required />
          </div>
        </div>

        <!-- 城市 -->
        <div class="row">
          <div class="control-label"><i class="fas fa-city"></i>城市:</div>
          <div class="box-body">
            <input type="text" v-model="formData.city" required />
          </div>
        </div>
        <!-- 邮箱 -->
        <div class="row">
          <div class="control-label"><i class="fas fa-envelope"></i>邮箱:</div>
          <div class="box-body">
            <input type="email" v-model="formData.email" required />
          </div>
        </div>

        <!-- 银行卡号 -->
        <div class="row">
          <div class="control-label">
            <i class="fas fa-credit-card"></i>银行卡:
          </div>
          <div class="box-body">
            <input type="number" v-model="formData.bankCardNumber" required />
          </div>
        </div>

        <!-- 开户行 -->
        <div class="row">
          <div class="control-label">
            <i class="fas fa-university"></i> 开户行:
          </div>
          <div class="box-body">
            <input type="text" v-model="formData.bankName" required />
          </div>
        </div>

        <!-- 地址 -->
        <div class="row">
          <div class="control-label">
            <i class="fas fa-map-marker-alt"></i>地址:
          </div>
          <div class="box-body">
            <input type="text" v-model="formData.address" required />
          </div>
        </div>

        <!-- 身份证人像 -->
        <div class="row">
          <div class="control-label">
            <i class="fas fa-id-badge"></i>身份证人像:
          </div>
          <div class="box-body">
            <input
              type="file"
              @change="handleFileChange($event, 'idPortrait', 'front')"
            />
            <img
              v-if="formData.idPortrait"
              :src="formData.idPortrait"
              alt="身份证人像"
            />
          </div>
        </div>

        <!-- 身份证国徽 -->
        <div class="row">
          <div class="control-label">
            <i class="fas fa-shield-alt"></i>身份证国徽:
          </div>
          <div class="box-body">
            <input
              type="file"
              @change="handleFileChange($event, 'idEmblem', 'back')"
            />
            <img
              v-if="formData.idEmblem"
              :src="formData.idEmblem"
              alt="身份证国徽预览"
            />
          </div>
        </div>

        <hr class="myhr" />

        <div class="row">
          <div class="control-label">
            <i class="fas fa-user-friends">联系人信息:</i>
          </div>
          <div class="box-body1">
            <table>
              <thead>
                <tr>
                  <th>关系</th>
                  <th>姓名</th>
                  <th>手机号</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(contact, index) in contacts" :key="index">
                  <td>
                    <input
                      type="text"
                      v-model="contact.relationship"
                      required
                    />
                  </td>
                  <td>
                    <input type="text" v-model="contact.name" required />
                  </td>
                  <td>
                    <input type="tel" v-model="contact.phoneNumber" required />
                  </td>
                  <td>
                    <button
                      v-if="contact.id"
                      @click="removeContact(contact.id)"
                      type="button"
                    >
                      删除
                    </button>
                    <button
                      v-else
                      @click="
                        addContact1(
                          contact.relationship,
                          contact.phoneNumber,
                          contact.name
                        )
                      "
                      type="button"
                    >
                      添加
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button @click="addContact" type="button" class="add">
              添加联系人
            </button>
          </div>
        </div>

        <hr class="myhr" />
        <br />
        <br />

        <!-- 还款方式 -->
        <div class="row">
          <div class="control-label">还款方式:</div>
          <div class="box-body">
            <input
              type="radio"
              id="equalPrincipalInterest"
              value="等额本息"
              v-model="formData.repaymentMethod"
            />
            <label for="equalPrincipalInterest">等额本息</label>
            <input
              type="radio"
              id="monthlyInterest"
              value="按月付息到期还本"
              v-model="formData.repaymentMethod"
            />
            <label for="monthlyInterest">按月付息到期还本</label>
          </div>
        </div>

        <!-- 下面的字段 -->
        <div class="row">
          <!-- 用途 -->
          <div class="control-label">用途:</div>
          <div class="box-body">
            <input type="text" v-model="formData.usage" required />
          </div>
        </div>
        <div class="row">
          <!-- 还款期数 -->
          <div class="control-label">还款期数:</div>
          <div class="box-body">
            <input type="number" v-model="formData.repaymentPeriods" required />
          </div>
        </div>
        <div class="row">
          <!-- 年华(%) -->
          <div class="control-label">年化(%):</div>
          <div class="box-body">
            <input
              type="text"
              v-model="formData.annualPercentageRate"
              required
            />
          </div>
        </div>
        <div class="row">
          <!-- 额度 -->
          <div class="control-label">额度:</div>
          <div class="box-body">
            <input type="text" v-model="formData.creditLimitRange" required />
          </div>
        </div>
        <div class="row">
          <!-- 提款金额 -->
          <div class="control-label">提款金额:</div>
          <div class="box-body">
            <input
              type="number"
              v-model="formData.withdrawalAmountRange"
              required
            />
          </div>
        </div>
        <div class="row">
          <!-- 创建时间 -->
          <div class="control-label">创建时间:</div>
          <div class="box-body">
            <input type="date" v-model="formData.startDate" required />
          </div>
        </div>
        <div class="row">
          <!-- 更新时间 -->
          <div class="control-label">更新时间:</div>
          <div class="box-body">
            <input type="date" v-model="formData.endDate" required />
          </div>
        </div>

        <br />
        <hr class="myhr" />
        <br />
        <button type="submit"><i class="fas fa-check"></i>更新</button>
        <button @click="resetForm"><i class="fas fa-redo"></i>重置</button>
      </form>
    </div>

    <!-- 模态框，用于放大图片 -->
    <div v-if="isModalOpen" class="modal" @click="isModalOpen = false">
      <img :src="modalImage" alt="放大图片" />
    </div>
    <CustomAlert v-if="showAlert" :message="alertMessage" :type="alertType" />
    <CustomConfirm
      :isVisible="isConfirmVisible"
      title="确认删除"
      message="您确定要删除这条记录吗？此操作无法撤销。"
      @confirm="confirmDelete"
      @cancel="() => (isConfirmVisible = false)"
    />
     <CustomConfirm
      class="confirm"
      :isVisible="isConfirmVisible1"
      title="确认删除"
      message="您确定要删除这条记录吗？此操作无法撤销。"
      @confirm="confirmDelete1"
      @cancel="() => (isConfirmVisible1 = false)"
    />
    <!-- 返回顶部图标 -->
    <div v-if="showBackToTop" class="back-to-top" @click="scrollToTop">↑</div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";

import CustomAlert from "@/components/CustomAlert.vue";
import CustomConfirm from "@/components/CustomConfirm.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "@/axios";

const store = useStore();
const router = useRouter();
const searchQuery = ref("");
const pageSize = ref(20);
const currentPage = ref(1);
const gotoPage = ref(1);
const isModalOpen = ref(false);
const modalImage = ref("");
const isMobile = ref(window.innerWidth <= 768);
const isDetailOpen = ref(false);
const selectedRow = ref({});
const showBackToTop = ref(false);
const isFilterOpen = ref(false);
const isCreating = ref(false);
const isListView = ref(true);

const filter = ref({
  company: "",
  email: "",
  industryPosition: "",
  city: "",
  bankCardNumber: "",
  bankName: "",
  repaymentMethod: "",
  repaymentPeriods: "",
  minCreditLimit: "",
  maxCreditLimit: "",
  minWithdrawalAmount: "",
  maxWithdrawalAmount: "",
  startDate: "",
  endDate: "",
});

const formData = ref({
  id: "",
  company: "",
  city: "",
  email: "",
  bankCardNumber: "",
  bankName: "",
  industryPosition: "",
  address: "",
  repaymentMethod: "",
  usage: "",
  repaymentPeriods: "",
  qrCode: null,
  annualPercentageRate: "",
  creditLimitRange: "",
  withdrawalAmountRange: "",
  startDate: "",
  endDate: "",
  idPortrait: null,
  idEmblem: null,
  front: null,
  back: null,
});

const contacts = ref([]);

const keyTranslations = {
  id: "编号",
  bankCardNumber: "银行卡号",
  bankName: "开户行",
  company: "公司",
  industryPosition: "行业职位",
  city: "城市",
  email: "邮箱",
  repaymentMethod: "还款方式",
  repaymentPeriods: "还款期数",
  annualRate: "年化(100%)",
  creditLimit: "额度",
  withdrawalAmount: "提款金额",
  purpose: "用途",
  idCardFront: "身份证人像",
  idCardBack: "身份证国徽",
  createdAt: "创建时间",
};

const pageTitle = ref("列表");

const tableData = ref([]);

const isConfirmVisible = ref(false);
const isConfirmVisible1 = ref(false);
const showAlert = ref(false);
const alertMessage = ref("");
const alertType = ref("");

const showCustomAlert = (message, type = "info") => {
  alertMessage.value = message;
  alertType.value = type;
  showAlert.value = true;
  setTimeout(() => {
    showAlert.value = false;
  }, 3000);
};

const isLoading = ref(false);

function addContact() {
  contacts.value.push({ name: "", phoneNumber: "", relationship: "" });
  console.log(contacts.value);
}

const fetchTableData = async () => {
   isLoading.value = true;
  try {
    const response = await axios.get("/details");
    if (response.status == 200) {
       if (response.data != null) {
        tableData.value = response.data;
      }else{
         tableData.value = [];
      }
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "获取数据失败", "error");
    console.error("获取数据失败:", error);
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }finally {
    isLoading.value = false; // 完成加载
  }
};

onMounted(fetchTableData);

const search = async () => {
  if (searchQuery.value == "") {
    fetchTableData();
  } else {
    try {
      const response = await axios.get(`/fuzzy?content=${searchQuery.value}`);
      if (response.status == 200) {
        if (response.data != null) {
          tableData.value = response.data;
        }
      } else {
        showCustomAlert(response.data.error, "error");
      }
    } catch (error) {
      showCustomAlert(error.response.data.error || "获取数据失败", "error");
      console.error("获取数据失败:", error);
      if (error.response.data.error == "登录过期") {
        localStorage.removeItem("loggedIn");
        store.dispatch("logout");
        router.push("/login");
      }
    }
  }
};

const filteredData = computed(() => {
  if (!searchQuery.value) {
    return tableData.value;
  }
  return tableData.value.filter(
    (row) =>
      row.bankCardNumber.includes(searchQuery.value) ||
      row.city.toString().includes(searchQuery.value) ||
      row.company.toString().includes(searchQuery.value) ||
      row.bankName.toString().includes(searchQuery.value)
  );
});

const filteredAndPaginatedData = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return filteredData.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.ceil(filteredData.value.length / pageSize.value);
});

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const toggleFilter = () => {
  isFilterOpen.value = !isFilterOpen.value;
};

const toggleView = () => {
  isListView.value = !isListView.value;
  if (isListView.value) {
    pageTitle.value = "列表";
    isCreating.value = false;
    fetchTableData();
  } else {
    pageTitle.value = "创建";
    isCreating.value = true;
    resetForm();
  }
};

const resetForm = () => {
  formData.value = {
    id: formData.value.id,
    company: "",
    city: "",
    email: "",
    bankCardNumber: "",
    bankName: "",
    address: "",
    idPortrait: null,
    idEmblem: null,
    repaymentMethod: "",
    usage: "",
    repaymentPeriods: "",
    qrCode: null,
    annualPercentageRate: "",
    creditLimitRange: "",
    withdrawalAmountRange: "",
    startDate: "",
    endDate: "",
  };
};

const resetFilter = () => {
  filter.value = {
    company: "",
    email: "",
    industryPosition: "",
    city: "",
    bankCardNumber: "",
    bankName: "",
    repaymentMethod: "",
    repaymentPeriods: "",
    minCreditLimit: "",
    maxCreditLimit: "",
    minWithdrawalAmount: "",
    maxWithdrawalAmount: "",
    startDate: "",
    endDate: "",
  };
};

const applyFilter = async () => {
  try {
    const response = await axios.get(`/search`, { params: filter.value });
    if (response.status == 200) {
      if (response.data != null) {
        tableData.value = response.data;
      } else {
        tableData.value = [];
      }
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "获取数据失败", "error");
    console.error("获取数据失败:", error);
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
};

function handleFileChange(event, fieldName, fieldName2) {
  const file = event.target.files[0];
  if (file && file.type.startsWith("image/")) {
    const reader = new FileReader();
    reader.onload = (e) => {
      formData.value[fieldName] = e.target.result;
      formData.value[fieldName2] = file;
    };
    reader.readAsDataURL(file);
  } else {
    showCustomAlert("请选择图片文件", "warning");
  }
}

const jumpToPage = () => {
  if (gotoPage.value >= 1 && gotoPage.value <= totalPages.value) {
    currentPage.value = gotoPage.value;
  }
};

const enlargeImage = (src) => {
  modalImage.value = src;
  isModalOpen.value = true;
};

const editRow = async (selectedRow) => {
  toggleView();
  formData.value.id = selectedRow.id;
  formData.value.company = selectedRow.company;
  formData.value.industryPosition = selectedRow.industryPosition;
  formData.value.city = selectedRow.city;
  formData.value.email = selectedRow.email;
  formData.value.bankCardNumber = selectedRow.bankCardNumber;
  formData.value.bankName = selectedRow.bankName;
  formData.value.idPortrait = selectedRow.idCardFront;
  formData.value.idEmblem = selectedRow.idCardBack;
  formData.value.repaymentMethod = selectedRow.repaymentMethod;
  formData.value.usage = selectedRow.purpose;
  formData.value.annualPercentageRate = selectedRow.annualRate;
  formData.value.withdrawalAmountRange = selectedRow.withdrawalAmount;
  formData.value.creditLimitRange = selectedRow.creditLimit;
  formData.value.address = selectedRow.detailedAddress;
  const date = new Date(selectedRow.createdAt);
  // 提取 YYYY-MM-DD 部分
  const formattedDate = date.toISOString().split("T")[0];
  formData.value.startDate = formattedDate;
  const date1 = new Date(selectedRow.updatedAt);
  // 提取 YYYY-MM-DD 部分
  const formattedDate1 = date1.toISOString().split("T")[0];
  formData.value.endDate = formattedDate1;
  formData.value.repaymentPeriods = selectedRow.repaymentPeriods;

  try {
    const response = await axios.get(`/contacts/${formData.value.id}`);
    if (response.status == 200) {
      if (response.data != null) {
        contacts.value = response.data;
      }
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "获取数据失败", "error");
    console.error("获取数据失败:", error);
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
};

const selectedRowId = ref("");
const selectedRowId1 = ref("");

const confirmDelete = async () => {
  // 删除逻辑
  try {
    const response = await axios.delete(`/contacts/${selectedRowId.value}`);
    if (response.status === 200) {
      showCustomAlert(response.data.message, "success");
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "删除失败", "error");
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
  try {
    const response = await axios.get(`/contacts/${formData.value.id}`);
    if (response.status == 200) {
      if (response.data != null) {
        contacts.value = response.data;
      }
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "获取数据失败", "error");
    console.error("获取数据失败:", error);
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
};

const confirmDelete1 = async()=> {
    // 删除逻辑
  try {
    const response = await axios.delete(`/details/${selectedRowId1.value}`);
    if (response.status === 200) {
      showCustomAlert(response.data.message, "success");
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "删除失败", "error");
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }finally{
    isConfirmVisible.value = false;
    isConfirmVisible1.value = false;
    selectedRowId.value = null;
    selectedRowId1.value = null;
    fetchTableData();
    isListView.value = true;
    pageTitle.value = "列表";
    isCreating.value = false;
  }
}

const removeContact = (id) => {
  selectedRowId.value = id;
  isConfirmVisible.value = true;
};

const addContact1 = async (relationship, phoneNumber, name) => {
  console.log(relationship, phoneNumber, name);
  var contracts = [];
  var contract = {
    relationship: relationship,
    name: name,
    phone_number: phoneNumber,
  };
  contracts.push(contract);
  var data1 = {
    userid: formData.value.id,
    contracts: contracts,
  };
  try {
    //上传
    const response1 = await axios.post("/emergency-contacts", data1);
    if (response1.status == 200) {
      showCustomAlert(response1.data.message, "success");
    } else {
      showCustomAlert(response1.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "提交失败", "error");
    console.error(error);
  }
};

const deleteRow = (id) => {
  selectedRowId1.value = id;
  isDetailOpen.value = false;
  isConfirmVisible1.value = true;
  console.log("删除行111:", id);
};

const showDetail = (row) => {
  selectedRow.value = row;
  isDetailOpen.value = true;
};

window.addEventListener("resize", () => {
  isMobile.value = window.innerWidth <= 768;
});

// 检测滚动事件
const handleScroll = () => {
  showBackToTop.value = window.scrollY > 200;
};

// 页面滚动到顶部
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const submitForm = async () => {
  const data = new FormData();
  data.append("id", formData.value.id);
  data.append("industry_position", formData.value.industryPosition);
  data.append("company", formData.value.company);

  data.append("residential_address", formData.value.city);
  data.append("email", formData.value.email);
  data.append("bank_account_number", formData.value.bankCardNumber);
  data.append("bank_name", formData.value.bankName);
  data.append("detailed_address", formData.value.address);

  data.append("loan_amount", formData.value.withdrawalAmountRange);
  data.append("repayment_periods", formData.value.repaymentPeriods);
  data.append("repayment_method", formData.value.repaymentMethod);
  data.append("purpose", formData.value.usage);
  data.append("annual_rate", formData.value.annualPercentageRate);
  data.append("credit_limit", formData.value.creditLimitRange);
  if(formData.value.front == null){
        data.append("id_card_front", "");
  }else{
    data.append("id_card_front", formData.value.front); 
  }
  if(formData.value.back == null){
 data.append("id_card_back", "");
  }else{
 data.append("id_card_back", formData.value.back);
  }
  
  try {
    const response = await axios.post("/details", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status == 200) {
      console.log(response);
      showCustomAlert(response.data.message, "success");
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "提交失败", "error");
    console.error(error);
  }
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>


<style scoped>
.main-form {
  padding: 24px 32px;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: linear-gradient(135deg, #f5f7fc 0%, #eef2f8 100%);
  min-height: 100vh;
  color: #1a2634;
}

/* ========== 头部区域 ========== */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 20px;
  backdrop-filter: blur(2px);
}

.header h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1f2b38, #2c3e4e);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  letter-spacing: -0.01em;
}

.header h3 {
  margin: 6px 0 0 4px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #5b6e8c;
}

/* 工具栏按钮组 */
.toolbar, .toolbar1 {
  display: flex;
  gap: 14px;
  align-items: center;
  flex-wrap: wrap;
}

.filter-btn, .add-btn {
  background: linear-gradient(105deg, #2c3e50 0%, #1e2a36 100%);
  border: none;
  padding: 10px 24px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  letter-spacing: 0.3px;
}

.filter-btn:hover, .add-btn:hover {
  background: linear-gradient(105deg, #1e2a36, #141f28);
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

/* 搜索栏 */
.search-bar {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 48px;
  padding: 6px 18px;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e2edf2;
  transition: all 0.2s;
}

.search-bar:focus-within {
  border-color: #8ba0b0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.search-bar i {
  color: #8ba0b0;
  font-size: 1rem;
}

.search-bar input {
  border: none;
  outline: none;
  background: transparent;
  width: 240px;
  font-size: 13px;
  padding: 8px 0;
}

/* ========== 表格容器 ========== */
.table-container {
  background: white;
  /* border-radius: 28px; */
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
  margin-bottom: 28px;
  transition: all 0.2s;
  border: 1px solid rgba(226, 237, 242, 0.6);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 1000px;
}

.data-table th {
  background: #fafcfd;
  color: #2c3e50;
  font-weight: 600;
  padding: 10px 6px;
  border-bottom: 1px solid #e9f0f3;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
}

.data-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #eff3f6;
  color: #2c3e50;
}

.data-table tr:hover td {
  background-color: #f8fbfd;
}

.data-table img {
  max-width: 44px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  cursor: pointer;
}

.data-table img:hover {
  transform: scale(1.02);
}

/* ========== 分页组件 (整洁现代) ========== */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  background: white;
  padding: 14px 20px;
  border-radius: 60px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  width: fit-content;
  margin: 0 auto;
  border: 1px solid #e9f0f3;
}

.pagination > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination button {
  background: white;
  border: 1px solid #dee7ec;
  padding: 8px 18px;
  border-radius: 32px;
  font-weight: 500;
  font-size: 0.85rem;
  color: #2c3e50;
  cursor: pointer;
  transition: 0.2s;
}

.pagination button:hover:not(:disabled) {
  background: #f0f4f9;
  border-color: #b9ccd9;
  transform: translateY(-1px);
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination select, .pagination input {
  border: 1px solid #dee7ec;
  border-radius: 32px;
  padding: 8px 14px;
  background: white;
  font-size: 0.85rem;
  outline: none;
  transition: 0.2s;
}

.pagination select:focus, .pagination input:focus {
  border-color: #8ba0b0;
  box-shadow: 0 0 0 2px rgba(99, 125, 145, 0.2);
}

.showPage {
  font-size: 0.85rem;
  color: #4a627a;
  margin-right: 6px;
}

.page-info {
  font-size: 0.85rem;
  background: #f2f6f9;
  padding: 6px 14px;
  border-radius: 32px;
  color: #2c3e50;
}

/* ========== 筛选侧边栏 (优雅玻璃质感) ========== */
.filter-sidebar {
  position: fixed;
  top: 80px;
  right: -100%;
  width: 340px;
  height: calc(100vh - 80px);
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(8px);
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.08);
  transition: right 0.3s cubic-bezier(0.2, 0.9, 0.4, 1.1);
  padding: 28px 24px;
  overflow-y: auto;
  z-index: 1000;
  border-left: 1px solid rgba(203, 213, 225, 0.5);
  border-radius: 32px 0 0 32px;
}

.filter-sidebar-open {
  right: 0;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
}

.filter-header button {
  flex: 1;
  background: #f0f4f9;
  border: none;
  padding: 10px 0;
  border-radius: 40px;
  font-weight: 600;
  color: #2c3e50;
  cursor: pointer;
  transition: 0.2s;
}

.filter-header button:hover {
  background: #e4ebf2;
}

.filter-body label {
  font-weight: 600;
  font-size: 0.8rem;
  color: #4a627a;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.3px;
}

.filter-body input, .filter-body select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #dfe8ef;
  border-radius: 20px;
  margin-bottom: 20px;
  font-size: 0.85rem;
  background: white;
  transition: 0.2s;
}

.filter-body input:focus, .filter-body select:focus {
  border-color: #8ba0b0;
  outline: none;
  box-shadow: 0 0 0 2px rgba(99, 125, 145, 0.2);
}

/* 手机筛选弹层 */
.mobile-filter {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80vh;
  background: white;
  border-radius: 32px 32px 0 0;
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.12);
  padding: 45px 24px 45px;
  overflow-y: auto;
  z-index: 1100;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.mobile-filter-header {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.mobile-filter-header button {
  flex: 1;
  padding: 12px;
  border-radius: 44px;
  background: #f0f4f9;
  border: none;
  font-weight: 600;
}

.mobile-filter-body > div {
  margin-bottom: 20px;
}

.mobile-filter-body label {
  font-weight: 600;
  font-size: 0.8rem;
  color: #4a627a;
  margin-bottom: 6px;
  display: block;
}

.mobile-filter-body input, .mobile-filter-body select {
  width: 100%;
  padding: 14px 16px;
  border-radius: 28px;
  border: 1px solid #e2edf2;
  background: #fff;
  font-size: 0.9rem;
}

.close-mobile-filter {
  position: absolute;
  top: 10px;
  right: 5px;
  background: #f0f4f9;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 30px;
  font-size: 1.4rem;
  cursor: pointer;
  color: #4a627a;
}

/* ========== 详情表单卡片 ========== */
.detail {
  background: white;
  border-radius: 32px;
  padding: 32px 36px;
  max-width: 880px;
  margin: 20px auto;
  box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.1);
  border: 1px solid #eef3f8;
}

.detail .row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
  flex-wrap: wrap;
}

.detail .control-label {
  width: 140px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.9rem;
  text-align: right;
}

.detail input, .detail select {
  flex: 1;
  padding: 12px 18px;
  border: 1px solid #dfe8ef;
  border-radius: 40px;
  font-size: 0.9rem;
  background: white;
  transition: 0.2s;
}

.detail input:focus, .detail select:focus {
  border-color: #8ba0b0;
  outline: none;
  box-shadow: 0 0 0 2px rgba(99, 125, 145, 0.15);
}

.detail button[type="submit"], .detail button[type="button"] {
  background: #2c3e50;
  color: white;
  border: none;
  padding: 12px 28px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  transition: 0.2s;
  align-items:center;
}

.detail button:hover {
  background: #1e2a36;
  transform: translateY(-1px);
}

/* 联系人表格区域 */
.box-body1 table {
  width: 100%;
  border-collapse: collapse;
  background: #fafcfd;
  border-radius: 24px;
  overflow: hidden;
}

.box-body1 th, .box-body1 td {
  padding: 12px 10px;
  border-bottom: 1px solid #eef3f8;
  text-align: left;
}

.box-body1 input {
  width: 100%;
  padding: 8px 12px;
  border-radius: 30px;
  border: 1px solid #e2edf2;
}

/* ========== 模态框(图片放大) ========== */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  cursor: pointer;
}

.modal img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 28px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

/* 详情弹窗 */
.detail-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.detail-content {
  background: white;
  padding: 28px;
  border-radius: 36px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.close-detail {
  float: right;
  background: none;
  border: none;
  font-size: 1.4rem;
  cursor: pointer;
  color: #6c86a3;
}

/* ========== 加载进度条 ========== */
.loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: #e2edf2;
  z-index: 2000;
}

.loading-bar-progress {
  height: 100%;
  background: linear-gradient(90deg, #2c3e50, #5d7f9e);
  animation: loading 1.2s infinite ease;
  width: 0%;
}

@keyframes loading {
  0% { width: 0%; left: 0; }
  50% { width: 70%; left: 15%; }
  100% { width: 100%; left: 0; }
}

/* ========== 返回顶部 ========== */
.back-to-top {
  position: fixed;
  bottom: 32px;
  right: 24px;
  width: 48px;
  height: 48px;
  background: #2c3e50;
  color: white;
  border-radius: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: 0.2s;
  z-index: 1000;
}

.back-to-top:hover {
  transform: translateY(-4px);
  background: #1e2a36;
}

/* ========== 响应式微调 ========== */
@media (max-width: 768px) {
  .main-form {
    padding: 20px 16px;
  }

  .toolbar, .toolbar1 {
    flex-direction: row;
  }

  .filter-btn {
    padding: 5px 10px;
    font-size: 13px;
  }

  .pagination button{
    padding: 3px 10px;
  }

  .header h1 {
    font-size: 1.5rem;
  }

  .pagination {
    border-radius: 40px;
    padding: 12px 18px;
    flex-direction: column;
    width: 100%;
  }

  .detail .row {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail .control-label {
    width: auto;
    text-align: left;
  }

  .search-bar input {
    width: 250px;
  }
  
  .jump {
     font-size: small;
  }

  .filter-sidebar {
    width: 85%;
    border-radius: 28px 0 0 28px;
  }
}

/* 按钮图标间距微调 */
button i, .add-btn i, .filter-btn i {
  margin-right: 6px;
  font-size: 13px;
}

/* 自定义alert 和 confirm 保持干净，不额外干扰 */
</style>


